import { useMemo } from "react";
import { decryptData } from "../../utils/encryptData";
import { SELECTED_MENU } from "../../utils/encryptedConstants.";
import { ADD, DELETE, EDIT, SESSION_STORAGE } from "../../common/masterEnums";

const getMenuFeatures = () => {
  try {
    const item = decryptData(SELECTED_MENU, SESSION_STORAGE);
    return item ? JSON.parse(item) : null;
  } catch (error) {
    console.error("Error", error);
    return null;
  }
};

const usePermissions = () => {
  const featureList = useMemo(() => getMenuFeatures() || [], []);

  const hasPermission = (featureId) => {
    return featureList.some((x) => x.FeatureId === featureId);
  };

  return {
    canAdd: hasPermission(ADD),
    canEdit: hasPermission(EDIT),
    canDelete: hasPermission(DELETE),
  };
};

export default usePermissions;
